class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    if (parsedState.sections) {
      this.renderSections(parsedState.sections);
      return;
    }

    fetchSectionsFallback(this.getSectionsToRender().map((section) => section.id))
      .then((sections) => this.renderSections(sections))
      .catch((e) => console.error(e));
  }

  renderSections(sections) {
    this.getSectionsToRender().forEach((section) => {
      const element = document.getElementById(section.id);
      if (!element || !sections[section.id]) return;
      const source = new DOMParser()
        .parseFromString(sections[section.id], 'text/html')
        .querySelector(section.selector || '.shopify-section');
      if (!source) return;
      element.innerHTML = source.innerHTML;
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        // The primary way into the order flow. Without this the button keeps whatever
        // enabled/disabled state the page was loaded with, which on a cold product page is
        // "empty cart, blocked" -- a dead button on the first thing a customer sees after
        // adding an item.
        id: 'cart-notification-cta',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
